import { Bus } from '../../../shared/lib/Bus.no-deps'
import { oneMinuteInMs } from '../../../shared/lib/duration.no-deps'
import { consoleLog } from '../../../shared/lib/functional/console.no-deps'
import { simpleError } from '../../src/utils/sentry'

export type Base_BusTaskType = 'sync' | 'todo_sync' | 'device_sync'
export type Base_Bus = Bus<Base_BusTaskType>

export function Base_createBus() {
    return new Bus<Base_BusTaskType>({
        singleHandlerPerType: true,
        singleTaskOfTypeInQueue: true,
        defaultTimeout: 5 * oneMinuteInMs,
        log: consoleLog,
        reportError: simpleError,
        requestIdleCallback: window.requestIdleCallback,
    })
}
